import { createSlice } from "@reduxjs/toolkit";
import {
  addSupplier,
  fetchSupplierById,
  fetchSuppliers,
  updateStatusInSupplier,
  updateSupplier
} from "./thunk";

interface State {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedSuppliers: any;
  categoryOptions: [];
}

const initialState: State = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedSuppliers: null,
  categoryOptions: []
};

const supplierSlice = createSlice({
  name: "supplier",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuppliers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSuppliers.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchSuppliers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Suppliers";
      })
      .addCase(fetchSupplierById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSupplierById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedSuppliers = action.payload;
      })
      .addCase(fetchSupplierById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addSupplier.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.list = state.list.map((category) =>
          category.id === action.payload.id ? action.payload : category
        );
      })
      .addCase(addSupplier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateSupplier.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.list = state.list.map((category) =>
          category.id === action.payload.id ? action.payload : category
        );
      })
      .addCase(updateSupplier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInSupplier.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInSupplier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      })
  },
});

export default supplierSlice.reducer;
